export default __webpack_public_path__ + "media/wallpaper/four_thumbnail_large-f17cf955.jpg";